"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ArticleVideoOutput = /** @class */ (function () {
    function ArticleVideoOutput() {
    }
    return ArticleVideoOutput;
}());
exports.ArticleVideoOutput = ArticleVideoOutput;
var ManualVideo = /** @class */ (function () {
    function ManualVideo() {
    }
    return ManualVideo;
}());
exports.ManualVideo = ManualVideo;
var OutputModule = /** @class */ (function () {
    function OutputModule() {
    }
    return OutputModule;
}());
exports.OutputModule = OutputModule;
var TemplateInfo = /** @class */ (function () {
    function TemplateInfo() {
    }
    return TemplateInfo;
}());
exports.TemplateInfo = TemplateInfo;
var TemplateRepositoryInfo = /** @class */ (function () {
    function TemplateRepositoryInfo() {
    }
    return TemplateRepositoryInfo;
}());
exports.TemplateRepositoryInfo = TemplateRepositoryInfo;
var VideoProduction = /** @class */ (function () {
    function VideoProduction() {
    }
    return VideoProduction;
}());
exports.VideoProduction = VideoProduction;
var VideoProductionCreate = /** @class */ (function () {
    function VideoProductionCreate() {
    }
    return VideoProductionCreate;
}());
exports.VideoProductionCreate = VideoProductionCreate;
var VideoProductionPhoto = /** @class */ (function () {
    function VideoProductionPhoto() {
    }
    return VideoProductionPhoto;
}());
exports.VideoProductionPhoto = VideoProductionPhoto;
var VideoProductionTask = /** @class */ (function () {
    function VideoProductionTask() {
    }
    return VideoProductionTask;
}());
exports.VideoProductionTask = VideoProductionTask;
var VideoQueue = /** @class */ (function () {
    function VideoQueue() {
    }
    return VideoQueue;
}());
exports.VideoQueue = VideoQueue;
